// extracted by mini-css-extract-plugin
module.exports = {"wrapTitle":"PopularCrypto_wrapTitle__WNO9Q","title":"PopularCrypto_title__M4pEt","viewLink":"PopularCrypto_viewLink__Qr_CL"};